import TreeItem from '@material-ui/lab/TreeItem';
import TreeView from '@material-ui/lab/TreeView';
import Icon from 'core/modules/atoms/Icon';
import PropTypes from 'prop-types';
import React from 'react';
import { getTreeFromFlatData } from './TreeView.service';
import TreeViewToSelectLabel from './TreeViewToSelectLabel';

function TreeViewToSelect({ search, selected, ...props }) {
  const data = getTreeFromFlatData({ flatData: props.data });
  const [expanded, setExpanded] = React.useState([]);

  React.useEffect(() => {
    if (search) {
      setExpanded(props.data.map((item) => item.guid));
    }
  }, [search]);

  const getChecked = (item) => {
    return item.isDisabled ? true : !!selected.find((element) => element && element.guid === item.guid);
  };

  const onChange = (dataChange) => {
    props.onChange(dataChange);
  };

  const handleChangeChecked = (item) => {
    const isChecked = selected.find((element) => element.guid === item.guid);

    if (!isChecked) {
      const dataChecked = [...selected, item];
      onChange(dataChecked);
    } else {
      const dataChecked = selected.filter((element) => element.guid !== item.guid);
      onChange(dataChecked);
    }
  };

  const _renderTree = (items) => {
    return items.map((item) => (
      <TreeItem
        nodeId={item.guid}
        label={TreeViewToSelectLabel({ getChecked, isSelectable: !item.children, item, onChange: handleChangeChecked })}
        key={item.guid}
      >
        {item.children ? _renderTree(item.children) : undefined}
      </TreeItem>
    ));
  };

  const _render = () => {
    return data.map((item) => (
      <TreeItem key={item.guid} nodeId={item.guid} label={TreeViewToSelectLabel({ getChecked, isSelectable: !item.children, item, onChange: handleChangeChecked })}>
        {item.children ? _renderTree(item.children) : undefined}
      </TreeItem>
    ));
  };

  return (
    <div className="tree-view-to-select">
      {!search && (
        <TreeView defaultCollapseIcon={<Icon type="chevron-up" />} defaultExpandIcon={<Icon type="chevron-right" />}>
          {_render()}
        </TreeView>
      )}

      {!!search && (
        <TreeView expanded={expanded} defaultCollapseIcon={<Icon type="chevron-up" />} defaultExpandIcon={<Icon type="chevron-right" />}>
          {_render()}
        </TreeView>
      )}
    </div>
  );
}

TreeViewToSelect.propTypes = {
  data: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  selected: PropTypes.array,
};

TreeViewToSelect.defaultProps = {
  data: [], // {guid, parent_guid, name, description, isDisabled}
  selected: [],
};

export default TreeViewToSelect;
